import { LineMarkerDefs } from 'widgets/LineWidget/LineRenders/LineMarkers';

interface CurvedLineIconProps {
  id: string;
  hasStartArrow?: boolean;
  hasEndArrow?: boolean;
}

/**
 * CURVED LINE ICON COMPONENT FOR LINE WIDGET MENU drag + drop image
 *
 * Note: Can't use Curved line render component directly since it uses complex hooks and will throw
 */
const LINE_ARROW_STYLE = 'lineArrow';
export const CurvedLineIcon = ({ hasStartArrow, hasEndArrow, id }: CurvedLineIconProps) => {
  const startArrowStyle = hasStartArrow ? LINE_ARROW_STYLE : 'none';
  const endArrowStyle = hasEndArrow ? LINE_ARROW_STYLE : 'none';
  return (
    <svg width={60} height={60} style={{ overflow: 'visible' }} fill='none'>
      <LineMarkerDefs startArrowStyle={startArrowStyle} endArrowStyle={endArrowStyle} strokeColor='#000' id={id} />
      <path
        d='M46,46L45.61666666666667,46C45.23333333333333,46,44.46666666666667,46,40.63333333333333,46C36.800000000000004,46,29.900000000000002,46,22.616666666666664,42.166666666666664C15.333333333333334,38.333333333333336,7.666666666666667,30.666666666666668,3.8333333333333335,23.383333333333336C0,16.099999999999998,0,9.200000000000001,0,5.366666666666667C0,1.5333333333333334,0,0.7666666666666667,0,0.38333333333333336L0,0'
        stroke='#000'
        strokeWidth={2}
        fill='transparent'
      />

      {/* ARROW ENDS */}
      <path
        d='M46,46L45.61666666666667,46C45.23333333333333,46,44.46666666666667,46,40.63333333333333,46C36.800000000000004,46,29.900000000000002,46,22.616666666666664,42.166666666666664C15.333333333333334,38.333333333333336,7.666666666666667,30.666666666666668,3.8333333333333335,23.383333333333336C0,16.099999999999998,0,9.200000000000001,0,5.366666666666667C0,1.5333333333333334,0,0.7666666666666667,0,0.38333333333333336L0,0'
        stroke='transparent'
        strokeWidth={4}
        fill='transparent'
        markerStart={`url(#start-arrow-${id})`}
        markerEnd={`url(#end-arrow-${id})`}
      />
    </svg>
  );
};
